// extracted by mini-css-extract-plugin
export var acitonButtons = "_ef-0";
export var additionalIcon = "_ef-f";
export var block = "_ef-1";
export var blockContent = "_ef-7";
export var blockDescription = "_ef-8";
export var blockIcon = "_ef-9";
export var blockTitle = "_ef-6";
export var border = "_ef-a";
export var center = "_ef-l";
export var edge = "_ef-b";
export var edgeLabel = "_ef-c";
export var edgePath = "_ef-d";
export var error = "_ef-e";
export var flowchart = "_ef-g";
export var flowchartContent = "_ef-h";
export var highlighted = "_ef-3";
export var hover = "_ef-4";
export var icon = "_ef-i";
export var left = "_ef-m";
export var navButton = "_ef-j";
export var navButtons = "_ef-k";
export var right = "_ef-n";
export var selected = "_ef-2";
export var small = "_ef-5";